import type { IconBaseProps } from "react-icons/lib";

export const KnowledgeBaseIcon = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6707_2761)">
      <path
        d="M16 3.46387V8.12105C15.6303 9.21074 12.5338 9.67793 11.5088 9.79699C9.08126 10.0795 6.63938 10.0726 4.21501 9.76105C3.22563 9.63387 0.361257 9.16355 -0.000305176 8.12512V3.46918C0.410945 4.54355 3.42626 5.00449 4.47157 5.12762C6.86876 5.41012 9.27719 5.4048 11.6706 5.11043C12.6831 4.98574 15.6144 4.5198 15.9997 3.46387H16ZM2.15532 6.01918C1.58001 6.12449 1.24126 6.67137 1.35813 7.21543C1.47032 7.73574 1.98532 8.08449 2.52188 7.98168C3.05251 7.88012 3.41469 7.36449 3.31657 6.82605C3.22032 6.2973 2.72157 5.91574 2.15501 6.01949L2.15532 6.01918Z"
        fill="currentColor"
      />
      <path
        d="M16 9.4632V14.1204C15.8222 14.6123 15.1534 14.9254 14.6675 15.1048C13.1925 15.6491 11.2738 15.8607 9.70719 15.9548C9.48719 15.9679 9.00906 15.9513 8.96875 15.9991H7.03125C6.98812 15.9504 6.51625 15.9688 6.29313 15.9548C4.71156 15.8566 2.80031 15.6485 1.31406 15.0963C0.83125 14.917 0.184062 14.6088 0 14.1241V9.4682C0.41125 10.5426 3.42656 11.0035 4.47188 11.1266C6.86906 11.4091 9.2775 11.4038 11.6709 11.1095C12.6834 10.9848 15.6147 10.5188 16 9.46289V9.4632ZM2.15531 12.0185C1.58 12.1238 1.24125 12.6707 1.35812 13.2148C1.47031 13.7351 1.98531 14.0838 2.52187 13.981C3.0525 13.8795 3.41469 13.3638 3.31656 12.8254C3.22031 12.2966 2.72156 11.9151 2.155 12.0188L2.15531 12.0185Z"
        fill="currentColor"
      />
      <path
        d="M9 0.000571934C8.9875 -0.00474057 9.03781 0.0286969 9.05062 0.0290094L9.70781 0.0449469C10.8878 0.0736969 15.5503 0.529634 16.0003 1.87963V2.1212C15.6306 3.21088 12.5341 3.67807 11.5091 3.79713C9.08156 4.07963 6.63969 4.07245 4.21531 3.7612C3.22656 3.63463 0.360312 3.1637 0 2.12557V1.87557C0.176563 1.40588 0.794375 1.09995 1.26156 0.922447C2.8225 0.330572 4.64406 0.161822 6.29187 0.0490094L7 0.000571934H9Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6707_2761">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CreateKnowledge = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 3.46387V8.12105C15.6303 9.21074 12.5338 9.67793 11.5088 9.79699C9.08126 10.0795 6.63938 10.0726 4.21501 9.76105C3.22563 9.63387 0.361257 9.16355 -0.000305176 8.12512V3.46918C0.410945 4.54355 3.42626 5.00449 4.47157 5.12762C6.86876 5.41012 9.27719 5.4048 11.6706 5.11043C12.6831 4.98574 15.6144 4.5198 15.9997 3.46387H16ZM2.15532 6.01918C1.58001 6.12449 1.24126 6.67137 1.35813 7.21543C1.47032 7.73574 1.98532 8.08449 2.52188 7.98168C3.05251 7.88012 3.41469 7.36449 3.31657 6.82605C3.22032 6.2973 2.72157 5.91574 2.15501 6.01949L2.15532 6.01918Z"
      fill="currentColor"
    />
    <path
      d="M16 9.4632V14.1204C15.8222 14.6123 15.1534 14.9254 14.6675 15.1048C13.1925 15.6491 11.2738 15.8607 9.70719 15.9548C9.48719 15.9679 9.00906 15.9513 8.96875 15.9991H7.03125C6.98812 15.9504 6.51625 15.9688 6.29313 15.9548C4.71156 15.8566 2.80031 15.6485 1.31406 15.0963C0.83125 14.917 0.184062 14.6088 0 14.1241V9.4682C0.41125 10.5426 3.42656 11.0035 4.47188 11.1266C6.86906 11.4091 9.2775 11.4038 11.6709 11.1095C12.6834 10.9848 15.6147 10.5188 16 9.46289V9.4632ZM2.15531 12.0185C1.58 12.1238 1.24125 12.6707 1.35812 13.2148C1.47031 13.7351 1.98531 14.0838 2.52187 13.981C3.0525 13.8795 3.41469 13.3638 3.31656 12.8254C3.22031 12.2966 2.72156 11.9151 2.155 12.0188L2.15531 12.0185Z"
      fill="currentColor"
    />
    <path
      d="M9 0.000571934C8.9875 -0.00474057 9.03781 0.0286969 9.05062 0.0290094L9.70781 0.0449469C10.8878 0.0736969 15.5503 0.529634 16.0003 1.87963V2.1212C15.6306 3.21088 12.5341 3.67807 11.5091 3.79713C9.08156 4.07963 6.63969 4.07245 4.21531 3.7612C3.22656 3.63463 0.360312 3.1637 0 2.12557V1.87557C0.176563 1.40588 0.794375 1.09995 1.26156 0.922447C2.8225 0.330572 4.64406 0.161822 6.29187 0.0490094L7 0.000571934H9Z"
      fill="currentColor"
    />
  </svg>
);

export const AddKnowledge = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.79961 3.2H3.99961C3.78744 3.2 3.58395 3.11571 3.43392 2.96569C3.28389 2.81566 3.19961 2.61217 3.19961 2.4C3.19961 2.18783 3.28389 1.98434 3.43392 1.83431C3.58395 1.68429 3.78744 1.6 3.99961 1.6H12.7996V0.8C12.7996 0.587827 12.7153 0.384344 12.5653 0.234315C12.4153 0.0842855 12.2118 0 11.9996 0L3.19961 0C2.77526 0 2.3683 0.168571 2.06824 0.468629C1.76818 0.768687 1.59961 1.17565 1.59961 1.6V14.4C1.59961 15.28 2.31961 16 3.19961 16H12.7996C13.224 16 13.6309 15.8314 13.931 15.5314C14.231 15.2313 14.3996 14.8243 14.3996 14.4V4C14.3996 3.78783 14.3153 3.58434 14.1653 3.43431C14.0153 3.28429 13.8118 3.2 13.5996 3.2H7.99961V9.6L6.39961 8L4.79961 9.6V3.2Z"
      fill="currentColor"
    />
  </svg>
);

export const BookIcon = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6834_1241)">
      <path
        d="M4.79961 3.2H3.99961C3.78744 3.2 3.58395 3.11571 3.43392 2.96569C3.28389 2.81566 3.19961 2.61217 3.19961 2.4C3.19961 2.18783 3.28389 1.98434 3.43392 1.83431C3.58395 1.68429 3.78744 1.6 3.99961 1.6H12.7996V0.8C12.7996 0.587827 12.7153 0.384344 12.5653 0.234315C12.4153 0.0842855 12.2118 0 11.9996 0L3.19961 0C2.77526 0 2.3683 0.168571 2.06824 0.468629C1.76818 0.768687 1.59961 1.17565 1.59961 1.6V14.4C1.59961 15.28 2.31961 16 3.19961 16H12.7996C13.224 16 13.6309 15.8314 13.931 15.5314C14.231 15.2313 14.3996 14.8243 14.3996 14.4V4C14.3996 3.78783 14.3153 3.58434 14.1653 3.43431C14.0153 3.28429 13.8118 3.2 13.5996 3.2H7.99961V9.6L6.39961 8L4.79961 9.6V3.2Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6834_1241">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowRight = (props: IconBaseProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.1593 6.20848C15.4597 5.90807 15.4597 5.42102 15.1593 5.12062L10.264 0.225267C9.96355 -0.0751366 9.4765 -0.0751365 9.1761 0.225267C8.8757 0.52567 8.8757 1.01272 9.1761 1.31312L13.5275 5.66455L9.1761 10.016C8.8757 10.3164 8.8757 10.8034 9.1761 11.1038C9.47651 11.4042 9.96356 11.4042 10.264 11.1038L15.1593 6.20848ZM0 5.66455L6.72483e-08 6.43378L14.6154 6.43378L14.6154 5.66455L14.6154 4.89532L-6.72483e-08 4.89532L0 5.66455Z"
    />
  </svg>
);

export const Plus = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 1L8 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15 8L1 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const User = (props: IconBaseProps): JSX.Element => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 10C10.9853 10 13 7.98528 13 5.5C13 3.01472 10.9853 1 8.5 1C6.01472 1 4 3.01472 4 5.5C4 7.98528 6.01472 10 8.5 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M1 21V15.1351C1 13.9559 2.21827 13 3.72684 13H13.2732C14.777 13 16 13.9559 16 15.1351V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuHome = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6572_2852)">
      <path
        d="M13.4131 6.01074L13.4727 6.0498L13.5 6.06348V13.0918C13.5 13.3055 13.3219 13.5 13.0752 13.5H2.9248C2.67809 13.5 2.5 13.3055 2.5 13.0918V6.06348L2.52734 6.0498L2.58691 6.01074L7.99902 2.51758L13.4131 6.01074Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_6572_2852">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuSettings = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6572_2860)">
      <path
        d="M16.0002 7.51381V8.51565C16.0002 8.92818 15.7056 9.2523 15.2942 9.31123L14.203 9.4291C13.9083 9.45856 13.6428 9.66483 13.5261 9.95949C13.4678 10.1657 13.3802 10.372 13.2898 10.5488C13.1439 10.814 13.2023 11.1676 13.3773 11.4033L14.0834 12.2578C14.3489 12.582 14.3197 13.0239 14.025 13.3186L13.319 14.0258C13.0243 14.3204 12.5808 14.3499 12.257 14.0847L11.4021 13.3775C11.1658 13.1713 10.842 13.1418 10.5473 13.2891C10.3401 13.3775 10.1651 13.4659 9.95793 13.5249C9.66325 13.6133 9.4561 13.8785 9.42693 14.2026L9.31023 15.2928C9.28105 15.7053 8.92802 16 8.51373 16H7.513C7.10162 16 6.77485 15.7053 6.7165 15.2928L6.59979 14.2026C6.57062 13.9079 6.36347 13.6427 6.0688 13.5249C5.86165 13.4659 5.65742 13.3775 5.47944 13.2891C5.21394 13.1418 4.86092 13.2007 4.62459 13.3775L3.76974 14.0847C3.44589 14.3499 3.00242 14.3204 2.70774 14.0258L2.00169 13.3186C1.70702 13.0239 1.67784 12.582 1.94334 12.2578L2.62022 11.4033C2.82737 11.1676 2.85654 10.8435 2.70774 10.5488C2.62022 10.3425 2.52977 10.1657 2.47142 9.95949C2.38389 9.66483 2.11839 9.45856 1.79454 9.4291L0.703368 9.31123C0.29199 9.28177 -0.00268555 8.92818 -0.00268555 8.51565V7.51381C-0.00268555 7.10129 0.29199 6.77716 0.703368 6.71823L1.79454 6.60037C2.08922 6.5709 2.35472 6.36464 2.47142 6.06998C2.52977 5.86372 2.6173 5.65746 2.70774 5.48066C2.85362 5.21547 2.79527 4.86188 2.62022 4.62615L1.94334 3.77164C1.67784 3.44751 1.70702 3.00552 2.00169 2.71087L2.70774 2.00368C3.00242 1.70902 3.44297 1.67956 3.76974 1.94475L4.62459 2.62247C4.86092 2.82873 5.18477 2.8582 5.47944 2.71087C5.68659 2.62247 5.86165 2.53407 6.0688 2.47514C6.36347 2.38674 6.57062 2.12155 6.59979 1.79742L6.7165 0.707182C6.74567 0.294659 7.0987 0 7.513 0H8.51373C8.92511 0 9.24896 0.294659 9.31023 0.707182L9.42693 1.79742C9.4561 2.09208 9.66325 2.35727 9.95793 2.47514C10.1651 2.53407 10.3693 2.62247 10.5473 2.71087C10.8128 2.8582 11.1658 2.79926 11.4021 2.62247L12.257 1.94475C12.5808 1.67956 13.0243 1.70902 13.319 2.00368L14.025 2.71087C14.3197 3.00552 14.3489 3.44751 14.0834 3.77164L13.3773 4.62615C13.1702 4.86188 13.141 5.186 13.2898 5.48066C13.3773 5.68692 13.4678 5.86372 13.5261 6.06998C13.6137 6.36464 13.8792 6.5709 14.203 6.60037L15.2942 6.71823C15.7056 6.7477 16.0002 7.10129 16.0002 7.51381ZM11.4021 8.01473C11.4021 6.15838 9.8704 4.62615 8.01482 4.62615C6.15924 4.62615 4.62751 6.15838 4.62751 8.01473C4.62751 9.87109 6.15924 11.4033 8.01482 11.4033C9.8704 11.3738 11.4021 9.87109 11.4021 8.01473Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6572_2860">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuSources = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6572_2868)">
      <g clipPath="url(#clip1_6572_2868)">
        <path
          d="M4.79961 3.2H3.99961C3.78744 3.2 3.58395 3.11571 3.43392 2.96569C3.28389 2.81566 3.19961 2.61217 3.19961 2.4C3.19961 2.18783 3.28389 1.98434 3.43392 1.83431C3.58395 1.68429 3.78744 1.6 3.99961 1.6H12.7996V0.8C12.7996 0.587827 12.7153 0.384344 12.5653 0.234315C12.4153 0.0842855 12.2118 0 11.9996 0L3.19961 0C2.77526 0 2.3683 0.168571 2.06824 0.468629C1.76818 0.768687 1.59961 1.17565 1.59961 1.6V14.4C1.59961 15.28 2.31961 16 3.19961 16H12.7996C13.224 16 13.6309 15.8314 13.931 15.5314C14.231 15.2313 14.3996 14.8243 14.3996 14.4V4C14.3996 3.78783 14.3153 3.58434 14.1653 3.43431C14.0153 3.28429 13.8118 3.2 13.5996 3.2H7.99961V9.6L6.39961 8L4.79961 9.6V3.2Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6572_2868">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_6572_2868">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuNotifications = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.0598 12.3141L12.9209 12.3158C13.33 12.3158 13.6815 12.0057 13.847 11.697C14.0596 11.3004 14.0512 10.8303 13.8166 10.4686C13.6575 10.2237 13.4795 10.0106 13.3066 9.77744C12.9403 9.28455 12.7145 8.72991 12.6157 8.10314C12.5191 7.48911 12.4928 6.8875 12.4919 6.26039C12.4881 4.07439 11.7857 2.49906 9.85448 1.63205C9.71156 1.13948 9.46293 0.718055 9.09107 0.408023C8.42805 -0.144935 7.54768 -0.130843 6.89029 0.419766C6.51969 0.730134 6.30515 1.15995 6.13533 1.62634C5.7225 1.85014 5.29436 2.06757 4.93157 2.39773C3.84416 3.38823 3.51109 4.77062 3.50827 6.26005C3.50702 6.88784 3.48169 7.48877 3.38443 8.10314C3.28716 8.7175 3.0598 9.28488 2.69326 9.77711C2.52407 10.0046 2.35394 10.2123 2.19506 10.4502C1.958 10.8048 1.93423 11.2719 2.14252 11.6756C2.29702 11.9755 2.63791 12.3137 3.06074 12.3137L3.0598 12.3141Z"
      fill="currentColor"
    />
    <path
      d="M5.78295 13.5494C6.22111 14.4537 7.06552 14.9875 7.98624 14.9996C9.42705 15.0184 10.2871 13.6558 10.1989 13.4625C10.1861 13.434 10.1267 13.3931 10.0885 13.3931H5.91087C5.8405 13.3931 5.79578 13.4608 5.78264 13.5494H5.78295Z"
      fill="currentColor"
    />
  </svg>
);

export const MenuThreads = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6572_3120)">
      <path
        d="M12.5069 16H11.8831C10.0991 15.8031 8.76656 14.3212 8.83781 12.5178C8.90812 10.7387 10.3781 9.33124 12.1522 9.31749C13.9378 9.30342 15.4253 10.7112 15.51 12.4881C15.5959 14.2919 14.2822 15.774 12.5069 16ZM13.5062 13.1462C13.7531 13.1462 13.9087 12.9253 13.8931 12.7215C13.8766 12.5044 13.7009 12.3522 13.4753 12.3525L12.5069 12.3531V10.6356C12.5069 10.3987 12.3359 10.2234 12.1159 10.2194C11.8959 10.2153 11.71 10.3825 11.71 10.6184L11.7116 12.769C11.7116 12.9669 11.8937 13.1459 12.0878 13.1459L13.5062 13.1465V13.1462Z"
        fill="currentColor"
      />
      <path
        d="M6.20875 15.8133C5.5225 15.818 4.89062 15.7077 4.21531 15.6555C2.41843 15.5168 0.938121 14.188 0.722809 12.3746C0.624059 11.5424 0.572809 10.724 0.546246 9.87895C0.485934 7.9702 0.493434 5.3152 0.728746 3.43333C0.902184 2.04489 1.87 0.86833 3.18343 0.417705C3.82875 0.196143 5.62687 0.0461426 6.31437 0.0445801L8.88875 0.0383301L9.32562 0.0633301C9.89906 0.0961426 10.4366 0.161455 11.0091 0.216768C12.7784 0.387705 14.2206 1.7752 14.3784 3.55458C14.4672 4.55645 14.5503 5.52333 14.5509 6.5252L14.5525 8.96552C12.6262 7.74302 10.1528 8.17708 8.76031 9.90177C7.3525 11.6452 7.46937 14.1755 9.09906 15.7949L6.20875 15.814V15.8133ZM10.9587 5.66833C11.3962 5.66833 11.6909 5.29427 11.6847 4.91489C11.6784 4.52145 11.3666 4.18396 10.9444 4.18364L4.15125 4.18302C3.71156 4.18302 3.3875 4.52771 3.39562 4.94239C3.40375 5.35708 3.72281 5.67052 4.15187 5.6702L10.9587 5.66833ZM8.03125 8.84864C8.475 8.84864 8.78093 8.48645 8.77437 8.09395C8.76781 7.70145 8.44218 7.36177 8.01468 7.36177L4.14906 7.36302C3.71843 7.36302 3.40031 7.71677 3.40875 8.12177C3.41687 8.51145 3.73031 8.84864 4.15031 8.84864H8.03093H8.03125Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6572_3120">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuOverview = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1.25"
      y="1.25"
      width="13.5"
      height="13.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M4.25 5.25H11.75M4.25 8H9.75M4.25 10.75H8.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const StarFavorite = (props: IconBaseProps): JSX.Element => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0L7.77041 3.56324L11.7063 4.1459L8.86458 6.93076L9.52671 10.8541L6 9.012L2.47329 10.8541L3.13542 6.93076L0.293661 4.1459L4.22959 3.56324L6 0Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowBack = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 8L2 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6 12L2 8L6 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoFull = (props: IconBaseProps): JSX.Element => (
  <svg
    width="83"
    height="20"
    viewBox="0 0 83 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6588_1091)">
      <path
        d="M18.6572 3.6573L17.2233 5.01417C16.1908 3.99419 15.0611 3.22327 13.8227 2.70244C12.5947 2.1816 11.3884 1.90981 10.2255 1.90981C8.76993 1.90981 7.38983 2.26841 6.07491 2.98456C4.75999 3.70071 3.73888 4.66694 3.02194 5.89359C2.29361 7.12025 1.93565 8.412 1.93565 9.76887C1.93565 11.1257 2.30499 12.4929 3.05504 13.7413C3.80509 15 4.83758 15.9879 6.16285 16.7041C7.47777 17.4202 8.93339 17.7788 10.4987 17.7788C12.4116 17.7788 14.0193 17.2363 15.3445 16.1615C16.6594 15.0868 17.4416 13.6979 17.6919 11.9824H11.7805V10.1915H19.7776C19.7559 13.0572 18.9086 15.3255 17.2243 17.0079C15.5401 18.6903 13.2796 19.5366 10.4552 19.5366C7.02153 19.5366 4.30479 18.3647 2.30602 16.0313C0.760398 14.229 0 12.156 0 9.79057C0 8.03274 0.445893 6.4041 1.32527 4.89532C2.20464 3.38655 3.42231 2.2033 4.95449 1.34558C6.49804 0.487849 8.2361 0.0651855 10.1811 0.0651855C11.7567 0.0651855 13.234 0.347305 14.6255 0.911545C15.9839 1.49749 17.3423 2.40895 18.6572 3.6573Z"
        fill="#434752"
      />
      <path
        d="M24.6575 0.0588379H28.5567C30.7355 0.0588379 32.2035 0.150811 32.9712 0.322356C34.1288 0.585875 35.0806 1.15838 35.8038 2.02954C36.5269 2.9007 36.8932 3.97648 36.8932 5.25997C36.8932 6.32541 36.6407 7.26478 36.1359 8.0667C35.631 8.87999 34.9203 9.4866 33.9912 9.89893C33.0622 10.3113 31.7783 10.5179 30.1272 10.5293L37.1373 19.5726H34.7289L27.7187 10.5293H26.618V19.5726H24.6575V0.0598713V0.0588379ZM26.6066 1.97167V8.61544L29.9782 8.63817C31.2859 8.63817 32.249 8.5121 32.8791 8.27131C33.5102 8.01916 33.9912 7.62957 34.3471 7.0798C34.703 6.53003 34.8747 5.92342 34.8747 5.24757C34.8747 4.57172 34.703 3.99921 34.3471 3.46081C33.9912 2.92241 33.5215 2.54418 32.9484 2.3158C32.3753 2.08638 31.4121 1.97167 30.0703 1.97167H26.6076H26.6066Z"
        fill="#434752"
      />
      <path
        d="M70.2785 0.000976562H74.1891C76.432 0.000976562 77.9497 0.104317 78.7318 0.299631C79.8471 0.57555 80.7678 1.13876 81.4806 1.99958C82.1934 2.86144 82.5504 3.92999 82.5504 5.22794C82.5504 6.5259 82.2048 7.61718 81.5034 8.4563C80.8133 9.3068 79.8471 9.88034 78.6284 10.1676C77.7428 10.3857 76.0751 10.489 73.6366 10.489H72.2338V19.553H70.2671V0.000976562H70.2785ZM72.2452 1.92001V8.57204L75.5692 8.60615C76.9151 8.60615 77.8928 8.48007 78.5135 8.23825C79.1343 7.99644 79.6288 7.59444 79.9857 7.055C80.3426 6.51557 80.5144 5.89449 80.5144 5.22794C80.5144 4.5614 80.3416 3.97546 79.9857 3.42465C79.6288 2.88521 79.1581 2.49459 78.5828 2.26414C77.9963 2.03472 77.0414 1.91898 75.7192 1.91898H72.2462L72.2452 1.92001Z"
        fill="#434752"
      />
      <path
        d="M49.2925 0H48.8228L39.5708 19.5479H41.7496L43.8466 15.1384L46.3802 9.76775L49.0515 4.14499L52.3879 11.2228H52.3765L54.1994 15.1384L56.3089 19.5479H58.4297L49.2925 0Z"
        fill="#0042EB"
      />
      <path
        d="M58.4875 0.000976562H56.2849L61.6139 11.2754H61.6025L63.4265 15.1951L65.5007 19.5716H67.6454L58.4875 0.000976562Z"
        fill="#0042EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_6588_1091">
        <rect width="82.5492" height="19.5717" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LogoShort = (props: IconBaseProps): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6588_1396)">
      <path
        d="M18.6572 3.62947L17.2233 4.98633C16.1908 3.96636 15.0611 3.19544 13.8227 2.67461C12.5947 2.15377 11.3884 1.88198 10.2255 1.88198C8.76993 1.88198 7.38983 2.24057 6.07491 2.95672C4.75999 3.67288 3.73888 4.63911 3.02194 5.86576C2.29361 7.09241 1.93565 8.38417 1.93565 9.74103C1.93565 11.0979 2.30499 12.4651 3.05504 13.7134C3.80509 14.9721 4.83758 15.9601 6.16285 16.6762C7.47777 17.3924 8.93339 17.751 10.4987 17.751C12.4116 17.751 14.0193 17.2084 15.3445 16.1337C16.6594 15.0589 17.4416 13.67 17.6919 11.9546H11.7805V10.1637H19.7776C19.7559 13.0293 18.9086 15.2977 17.2243 16.98C15.5401 18.6624 13.2796 19.5088 10.4552 19.5088C7.02153 19.5088 4.30479 18.3369 2.30602 16.0035C0.760398 14.2012 0 12.1282 0 9.76274C0 8.00491 0.445893 6.37626 1.32527 4.86749C2.20464 3.35872 3.42231 2.17547 4.95449 1.31774C6.49804 0.460017 8.2361 0.0373535 10.1811 0.0373535C11.7567 0.0373535 13.234 0.319473 14.6255 0.883713C15.9839 1.46965 17.3423 2.38112 18.6572 3.62947Z"
        fill="#959595"
      />
    </g>
    <defs>
      <clipPath id="clip0_6588_1396">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Approve = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.1665 7.98301L6.42457 11.833L14.1665 4.83301"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Trash = (props: IconBaseProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.18359 4.8025V13.2716C3.18359 14.2222 3.94421 15 4.87389 15H11.1268C12.0564 15 12.8171 14.2222 12.8171 13.2716V4.8025H3.18359ZM6.05607 13.4434H5.21095V6.35699H6.05607V13.4434ZM8.42245 13.4434H7.57734V6.35699H8.42245V13.4434ZM10.7889 13.4434H9.94374V6.35699H10.7889V13.4434Z"
      fill={props.color || "currentColor"}
    />
    <path
      d="M9.26721 2.20987V1H6.73177V2.20987H2V3.93826H14V2.20987H9.26721Z"
      fill={props.color || "currentColor"}
    />
  </svg>
);

export const UploadFile = (props: IconBaseProps): JSX.Element => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="60" height="60" rx="30" fill="#E0EBFE" />
    <g clipPath="url(#clip0_6298_24806)">
      <path
        d="M28.719 18.6901C28.0896 18.6901 27.5747 18.178 27.5747 17.5487C27.5747 16.9193 27.0598 16.4072 26.4304 16.4072H16.7038C16.0744 16.4072 15.5594 16.9193 15.5594 17.5487V37.391C15.5594 38.0175 16.0744 38.5325 16.7038 38.5325H38.9263C39.5556 38.5325 40.0706 38.0175 40.0706 37.3882V19.8344C40.0706 19.2051 39.5556 18.6901 38.9263 18.6901H28.7162H28.719Z"
        fill="#3372E8"
      />
      <path
        d="M38.4221 20.5947H15.6275C14.6795 20.5947 13.911 21.3632 13.911 22.3112V38.7206C13.911 39.6686 14.6795 40.4371 15.6275 40.4371H38.4221C39.3701 40.4371 40.1386 39.6686 40.1386 38.7206V22.3112C40.1386 21.3632 39.3701 20.5947 38.4221 20.5947Z"
        fill="#68A6FF"
      />
      <path
        d="M40.1308 43.589C43.4203 43.589 46.0869 40.9224 46.0869 37.6329C46.0869 34.3434 43.4203 31.6768 40.1308 31.6768C36.8413 31.6768 34.1747 34.3434 34.1747 37.6329C34.1747 40.9224 36.8413 43.589 40.1308 43.589Z"
        fill="white"
      />
      <path
        d="M43.0303 37.1127L40.1094 34.5752L37.2372 37.2071L37.8265 37.8508L39.6774 36.1543V40.7173H40.5528V36.12L42.4552 37.7735L43.0303 37.1127Z"
        fill="#3372E8"
      />
    </g>
    <defs>
      <clipPath id="clip0_6298_24806">
        <rect
          width="32.178"
          height="27.1774"
          fill="white"
          transform="translate(13.911 16.4111)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const InfoCircle = (props: IconBaseProps): JSX.Element => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_info_circle)">
      <path
        d="M8.30996 0C3.72001 0 0 3.49879 0 7.81579C0 12.1328 3.72001 15.6316 8.30996 15.6316C12.8999 15.6316 16.6199 12.1328 16.6199 7.81579C16.6199 3.49879 12.8999 0 8.30996 0ZM9.47855 11.7176C9.47855 12.3251 8.95593 12.8167 8.30996 12.8167C7.66399 12.8167 7.14137 12.3251 7.14137 11.7176V7.12275C7.14137 6.51519 7.66399 6.02365 8.30996 6.02365C8.95593 6.02365 9.47855 6.51519 9.47855 7.12275V11.7176ZM8.30996 5.0131C7.66399 5.0131 7.14137 4.52156 7.14137 3.914C7.14137 3.30645 7.66399 2.81491 8.30996 2.81491C8.95593 2.81491 9.47855 3.30645 9.47855 3.914C9.47855 4.52156 8.95593 5.0131 8.30996 5.0131Z"
        fill="#08A53E"
      />
    </g>
    <defs>
      <clipPath id="clip0_info_circle">
        <rect width="16.6199" height="15.6316" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Eye = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_eye)">
      <path
        d="M11.1261 13.2579C9.20837 14.2119 7.08031 14.2459 5.15404 13.3617C3.00192 12.3734 1.40076 10.5433 0.146151 8.48283C-0.0487172 8.16262 -0.0487172 7.8375 0.146151 7.51764C1.4001 5.45749 3.00192 3.62671 5.15306 2.63872C7.01502 1.78366 9.07252 1.78682 10.9318 2.64995C13.0757 3.6453 14.7158 5.51185 15.949 7.58568C16.0169 7.87116 16.0169 8.1293 15.949 8.41443C14.7567 10.416 13.1892 12.231 11.1261 13.2576V13.2579ZM8.01574 12.2738C10.2592 12.2587 12.0074 10.3585 12.0074 8.00128C12.0074 5.62022 10.2351 3.73123 7.99893 3.72561C5.75481 3.72 3.96934 5.61286 3.96967 8.00093C3.96999 10.389 5.75019 12.2889 8.01541 12.2738H8.01574Z"
        fill="currentColor"
      />
      <path
        d="M10.1547 6.89876C10.3687 7.31718 10.4185 7.75979 10.3905 8.20661C10.3044 9.56742 9.26679 10.5596 8.00163 10.5656C6.63755 10.5719 5.57682 9.44992 5.57715 7.99863C5.57781 6.61713 6.5571 5.49236 7.87172 5.44186C8.27201 5.42643 8.66372 5.48219 9.02411 5.69859C8.71615 6.03037 8.70659 6.58276 9.02214 6.91244C9.33274 7.23651 9.84217 7.22494 10.1547 6.89911V6.89876Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_eye">
        <rect width="16" height="12" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);

export const EyeOff = (props: IconBaseProps): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_eyeoff)">
      <path
        d="M11.1261 13.2579C9.20837 14.2119 7.08031 14.2459 5.15404 13.3617C3.00192 12.3734 1.40076 10.5433 0.146151 8.48283C-0.0487172 8.16262 -0.0487172 7.8375 0.146151 7.51764C1.4001 5.45749 3.00192 3.62671 5.15306 2.63872C7.01502 1.78366 9.07252 1.78682 10.9318 2.64995C13.0757 3.6453 14.7158 5.51185 15.949 7.58568C16.0169 7.87116 16.0169 8.1293 15.949 8.41443C14.7567 10.416 13.1892 12.231 11.1261 13.2576V13.2579ZM8.01574 12.2738C10.2592 12.2587 12.0074 10.3585 12.0074 8.00128C12.0074 5.62022 10.2351 3.73123 7.99893 3.72561C5.75481 3.72 3.96934 5.61286 3.96967 8.00093C3.96999 10.389 5.75019 12.2889 8.01541 12.2738H8.01574Z"
        fill="currentColor"
      />
      <path
        d="M10.1547 6.89876C10.3687 7.31718 10.4185 7.75979 10.3905 8.20661C10.3044 9.56742 9.26679 10.5596 8.00163 10.5656C6.63755 10.5719 5.57682 9.44992 5.57715 7.99863C5.57781 6.61713 6.5571 5.49236 7.87172 5.44186C8.27201 5.42643 8.66372 5.48219 9.02411 5.69859C8.71615 6.03037 8.70659 6.58276 9.02214 6.91244C9.33274 7.23651 9.84217 7.22494 10.1547 6.89911V6.89876Z"
        fill="currentColor"
      />
    </g>
    <line x1="2.35355" y1="13.6464" x2="13.6464" y2="2.35355" stroke="currentColor" strokeLinecap="round" />
    <defs>
      <clipPath id="clip0_eyeoff">
        <rect width="16" height="12" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);
